import * as z from 'zod';

import { removeHTMLTags } from 'utils/validation';

export const privacySchema = z.object({
  title: z.string().min(1, 'Required'),
  body: z.string().refine((val) => removeHTMLTags(val).length !== 0, {
    message: 'Required',
  }),
});

export type IPrivacySchema = z.infer<typeof privacySchema>;
